import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Tooltip from "@mui/material/Tooltip";
import { useMediaQuery } from "@mui/material";

const TopToolBarStateSearch = ({
  table,
  exportAllData,
  exportPageData,
  exportSelectedData,
}) => {
  const isTablet = useMediaQuery("(max-width:1024px)");
  const isMobile = useMediaQuery("(max-width:600px)");

  const selectButtonDisabled =
    !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected();

  // Wrap the Selected Rows Export Button with Tooltip
  const SelectedRowsExportButton = (
    <span>
      <Button
        disabled={selectButtonDisabled}
        onClick={() =>
          exportSelectedData(
            table.getSelectedRowModel().rows.map((row) => row.original)
          )
        }
        startIcon={
          <FileDownloadIcon
            sx={{ fontSize: isMobile ? 20 : isTablet ? 24 : 28 }}
          />
        }
        sx={{ fontSize: isMobile ? 12 : isTablet ? 14 : 16 }}
      >
        {isTablet ? "Selected" : "Export Selected Rows"}
      </Button>
    </span>
  );

  // Use Tooltip if the button is not disabled
  const TooltipWithButton = ({ children }) => (
    <Tooltip title="Export Selected Rows">{children}</Tooltip>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: isTablet ? 1 : 2,
        padding: isTablet ? 0 : 1,
      }}
    >
      <Tooltip title="Export All Data">
        <span>
          <Button
            onClick={exportAllData}
            startIcon={
              <FileDownloadIcon
                sx={{ fontSize: isMobile ? 20 : isTablet ? 24 : 28 }}
              />
            }
            sx={{ fontSize: isMobile ? 12 : isTablet ? 14 : 16 }}
          >
            {isTablet ? "All" : "Export All Data"}
          </Button>
        </span>
      </Tooltip>

      <Tooltip title="Export Page Rows">
        <span>
          <Button
            disabled={table.getRowModel().rows.length === 0}
            onClick={() =>
              exportPageData(
                table.getRowModel().rows.map((row) => row.original)
              )
            }
            startIcon={
              <FileDownloadIcon
                sx={{ fontSize: isMobile ? 20 : isTablet ? 24 : 28 }}
              />
            }
            sx={{ fontSize: isMobile ? 12 : isTablet ? 14 : 16 }}
          >
            {isTablet ? "Page" : "Export Page Rows"}
          </Button>
        </span>
      </Tooltip>

      {selectButtonDisabled ? (
        SelectedRowsExportButton
      ) : (
        <TooltipWithButton>{SelectedRowsExportButton}</TooltipWithButton>
      )}
    </Box>
  );
};

export default TopToolBarStateSearch;
